import React, { useState, useEffect } from 'react'
import { Divider, Checkbox } from '@material-ui/core'
import {
  Link,
} from 'react-router-dom'
import {
  useDispatch,
  useSelector,
} from 'react-redux'
import { selectUserInfo } from 'src/app/slices/userSlice'
import styles from './ProressionalCourse.module.css'
import {
  selectorCourseBasket,
  addBasket, deleteCourseBasket,
} from '../../../app/slices/courseSlice'

function BasketCard({
  video, bought, course, perofessional,
  admin,
}) {
  const [add, setAdd] = useState(false)
  const courseBasket = useSelector(selectorCourseBasket)
  const { role } = useSelector(selectUserInfo)
  const dispatch = useDispatch()

  useEffect(() => {
    const basketed = courseBasket?.items?.find((item) => course?.id === item?.courseGroup?.id)
    if (basketed) {
      setAdd(true)
    }
  }, [courseBasket?.items?.length])

  const handleAddCheck = (e) => {
    setAdd(e.target.checked)
    if (e.target.checked) {
      dispatch(addBasket(course?.id))
    } else if (e.target.checked === false) {
      const basketed = courseBasket?.items?.find((item) => course?.id === item?.courseGroup?.id)

      const data = [basketed?.id]

      dispatch(deleteCourseBasket(data))
    }
  }

  let customLink = ''
  if (bought) {
    customLink = ['episode', video?.id].join('/')
  } else if (perofessional) {
    customLink = ['course', course?.id].join('/')
  }

  let courseTime = null
  let courseTimeText = null

  if (video?.length / 60 < 1) {
    courseTime = video?.length.toFixed()
    courseTimeText = 'ثانیه'
  } else if (video?.length / 60 > 1) {
    courseTime = (video?.length / 60).toFixed()
    courseTimeText = 'دقیقه'
  } else if (video?.length / 60 > 60) {
    courseTime = ((video?.length / 60) / 60).toFixed()
    courseTimeText = 'ساعت'
  }

  console.log('baskets', course)

  return (
    <div className={styles.basketCard}>
      <Link
        to={customLink}
      >
        <div
          className={styles.basketCardImgWrap}
        >
          <p
            style={{ color: '#3a455d' }}
          >
            <img
              alt="Remy Sharp"
              src={course?.imageUrl || course?.image ? course?.image || course?.imageUrl : `${window.location.origin}/images/row-students-doing-exam_1098-174.jpg`}
              className={styles.basketCardImg}
            />
          </p>
        </div>
      </Link>
      <div className={styles.basketTitle}>
        <Link
          to={bought ? ['episode', video?.id].join('/') : '/app/courses/user/professional-courses/course/1'}
          style={{ color: '#3a455d' }}
        >
          {bought ? video?.title : course?.title}
        </Link>
      </div>
      <Divider style={{ width: '85%', margin: '0 auto' }} />
      {!bought && !admin && [1].includes(role?.roleId) ? (
        <div className={styles.addBasket}>
          <Checkbox
            id={course?.id}
            checked={add === true}
            onChange={handleAddCheck}
            inputProps={{ 'aria-label': 'primary checkbox' }}
          />
          { !add && (
          <label htmlFor={course?.id} className={styles.addBasketText}>
            انتخاب کنید
          </label>
          )}
        </div>
      ) : (
        <div
          className={styles.addBasket}
        >
          {courseTime}
          {' '}
          {courseTimeText}
        </div>
      )}
    </div>
  )
}

export default BasketCard
